import {connect} from 'react-redux';
import MemorialDetails from 'app/components/RightBarPane/Property/MemorialDetails';
import {convertListToArray} from 'app/shared/utils';

export const mapStateToProps = (state) => ({
    memorialDetails: convertListToArray(state.getIn(['property', 'selectedProperty', 'memorialDetails'])),
});

export default connect(mapStateToProps, null)(MemorialDetails);